/*
 * @Autor: xx
 * @Version: 1.0
 * @Date: 2020-06-16 20:41:05
 * @LastEditors: xx
 * @Description:
 * @LastEditTime: 2020-06-16 21:59:27
 */

import { objAny } from "../common/common-interface";
export const routerFor = (list: object[], key?: string): object[] => {
  const arr: object[] = [];
  list.map((item: objAny, index: number) => {
    let isTrue = false;
    if (item.privilegeVoList) {
      item.privilegeVoList.map((vo: objAny) => {
        if (vo.privilegeCode == "100501" && vo.checked) {
          isTrue = true;
        }
      });
    }
    if (!item.privilegeVoList) {
      isTrue = true;
    }
    if (key) {
      item.menuIndex = key + "-" + index;
    } else {
      item.menuIndex = index + "";
    }
    if (item.children) {
      item.children = routerFor(item.children, item.menuIndex);
    }

    if (isTrue) {
      arr.push(item);
    }
  });
  return arr;
};
